import MeshBackground from "@/components/MeshBackground";
import { useLang } from "@/i18n";
import { Lock, ShieldCheck, ScrollText } from "lucide-react";

export default function SecuritySection() {
  const { t } = useLang();
  const points = [
    { icon: Lock, title: t("sec.p1"), desc: t("sec.p1d") },
    { icon: ShieldCheck, title: t("sec.p2"), desc: t("sec.p2d") },
    { icon: ScrollText, title: t("sec.p3"), desc: t("sec.p3d") },
  ];
  const stats = [
    { v: "98%", l: t("sec.stat1") },
    { v: "100%", l: t("sec.stat2") },
    { v: "24/7", l: t("sec.stat3") },
  ];
  return (
    <section className="relative clip-diagonal bg-[#0A2540] py-28 overflow-hidden" data-testid="security-section">
      <MeshBackground className="absolute inset-0" opacity={0.2} beams />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-emerald-400">{t("sec.eyebrow")}</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-3">
            {t("sec.title")}
          </h2>
          <p className="text-slate-400 mt-4 leading-relaxed">{t("sec.body")}</p>
          <div className="mt-8 space-y-5">
            {points.map((p) => (
              <div key={p.title} className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center shrink-0">
                  <p.icon size={18} className="text-emerald-400" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">{p.title}</p>
                  <p className="text-sm text-slate-400 mt-0.5">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1582139329536-e7284fece509?auto=format&fit=crop&w=900&q=80"
            alt="Vault security"
            loading="lazy"
            className="rounded-2xl border border-white/10 shadow-2xl shadow-black/50 w-full object-cover aspect-[4/3]"
          />
          <div className="absolute -bottom-8 -right-4 sm:-right-8 glass-strong rounded-2xl p-5 shadow-2xl shadow-black/60 animate-float-slow">
            <div className="flex gap-6">
              {stats.map((s) => (
                <div key={s.l} className="text-center">
                  <p className="font-ticker text-xl font-semibold text-emerald-400">{s.v}</p>
                  <p className="text-[10px] text-slate-500 mt-1 max-w-[90px]">{s.l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
